import { faDownload } from "@fortawesome/pro-solid-svg-icons/faDownload";
import { faExternalLinkSquare } from "@fortawesome/pro-solid-svg-icons/faExternalLinkSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid } from '@mui/material';
import { withStyles, WithStyles } from "@mui/styles";
import MuiLink from "components/MuiExtras/MuiLink";
import { Formaters } from 'lib/Formarters';
import LibUtils from 'lib/LibUtils';
import HtmlUtils from 'lib/HtmlUtils';
import MediaUtils from 'lib/MediaUtils';
import { FileGetDto } from 'models/ApiModels';
import * as React from 'react';
import { CourseActions } from "views/Publication/Components/CourseModels";
import { styles } from "./FileOrMetadataStyles";

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    file: FileGetDto;
    enableDownload?: boolean;
    autoCompleteCourse?: boolean;
    onCustomAction?: (action: any) => Promise<boolean>;
}

type Props = IProps & WithStyles<typeof styles>;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const RenderFile: React.FC<Props> = (props) => {

    const { classes, file, enableDownload, autoCompleteCourse, onCustomAction } = props;

    const isOffice = MediaUtils.isOfficeDocument(file.metadata.fileExtension) && !HtmlUtils.isLocalhost();
    const isPdf = MediaUtils.isPDF(file.metadata.fileExtension);

    const url = isOffice
        ? MediaUtils.makeOfficeViewerUrl(file.url)
        : file.url;

    const handleClickLink = () => {
        if (autoCompleteCourse)
            onCustomAction({ execution: { actionName: "complete" } as CourseActions });
    }

    const grid = (
        <Grid container className={classes.container} spacing={1} style={{ height: 100 }}>
            <Grid item>
                <img src={MediaUtils.getImageFromMimeType(file.mimeType, file.metadata.fileExtension)} alt={file.metadata.fileExtension} className={classes.imgSmall} />
            </Grid>
            <Grid item xs className={classes.columnMiddle}>
                <span className={classes.title}>
                    {file.metadata.title != null && file.metadata.title != "" ? file.metadata.title : file.metadata.filename}
                </span>
                {file.metadata.description && <p style={{ marginBlockStart: '0.25em', marginBlockEnd: 0 }}>{LibUtils.truncateText(file.metadata.description, 250)}</p>}
                {!enableDownload && <div className={classes.metainfo}>{Formaters.fileSize(file.metadata.fileSize)}</div>}
            </Grid>
            {
                enableDownload
                    ? (
                        <div className={classes.columnRight}>
                            <FontAwesomeIcon icon={isOffice || isPdf ? faExternalLinkSquare : faDownload} size="2x" />
                            {
                                !isOffice &&
                                <>
                                    <br />
                                    <div className={classes.metainfo}>{Formaters.fileSize(file.metadata.fileSize)}</div>
                                </>
                            }
                        </div>
                    )
                    : null
            }
        </Grid>
    );

    return enableDownload
        ? <MuiLink onClick={handleClickLink} underline="none" href={url} target="_blank" rel="noopener noreferrer">{grid}</MuiLink>
        : grid;
};

export default withStyles(styles)(RenderFile);